import RequestItem from "./RequestItem";

const RequestList = ({ requests, isLoading, error, onConfirm, onDelete, isAccepting, isDeleting }) => {
    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Something went wrong!</div>;

    if (!requests || requests.length === 0) {
        return <span className="noRequest">No Friend Requests</span>;
    }

    return (
        <>
            {requests.map((request) => (
                <RequestItem
                key={request.id}
                request={request}
                onConfirm={onConfirm}
                onDelete={onDelete}
                isAccepting={isAccepting}
                isDeleting={isDeleting}
                />
            ))}
        </>
    );
};

export default RequestList;